module.exports = "/packs/008-f245dc01bab9e459021f20e4206873e4.jpg";